import { toast } from 'sonner';

/**
 * Show a confirmation toast with action buttons
 * @param {string} message - The confirmation message
 * @param {function} onConfirm - Callback when user confirms
 * @param {object} options - Additional options (title, confirmText, cancelText)
 */
export const confirmToast = (message, onConfirm, options = {}) => {
  const {
    title = 'Confirm Action',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    description = message
  } = options;

  toast(title, {
    description,
    action: {
      label: confirmText,
      onClick: onConfirm
    },
    cancel: {
      label: cancelText,
      onClick: () => {}
    },
    duration: 10000,
  });
};

export default confirmToast;
